import React from "react";

function NoPage() {
    return (
        <div>
            <h2>{"No Page Found."}</h2>
        </div>
    )
}

export default NoPage;